import {PaginaLogada} from "../../componentes";
import {Card} from "../../componentes/card/Card";
import {useEffect, useState} from "react";
import {formatarDinheiroItl} from "../../util/mascara";
import {USUARIO} from "../../util";
import {DemandaServico} from "../../servicos";
import {useParams} from "react-router-dom";

export default function VisualizarDemanda() {

  const parametros = useParams()
  const [demanda, setDemanda] = useState({})
  const [itens, setItens] = useState([])
  const [total, setTotal] = useState(0.00)
  const [isCarregando, setIsCarregando] = useState(false)



  function getForca() {
    let usuario = JSON.parse(localStorage.getItem(USUARIO));
    return usuario.email.split('@')[1].split('.')[0].toString().toUpperCase();
  }

  function carregarDod() {
    DemandaServico.buscarDemanda(parametros.id)
      .then(dod => {
        setDemanda(dod)
        setItens(dod.items)
      })
  }

  function calculaValorTotal() {
    let valorFinal = 0
    return formatarDinheiroItl(itens.reduce((p, c) =>  p += c.quantidade * c.valorUnitario, valorFinal))
  }

  function getUnidade(demanda) {
    if (demanda.delegacia) {
    return <>
      <label>Delegacia requerente:</label>
      <input
        value={demanda.delegacia.nome}
        className="form-control"
        readOnly
      />
    </>
    } else {
      return <>
        <label>Unidade requerente:</label>
        <input
          value={demanda.unidadeRequisitante}
          className="form-control"
          readOnly
        />
      </>
    }
  }


  useEffect(() => {
    carregarDod()
  }, [])

  return (
    <PaginaLogada titulo="Visualizar Demanda" isCarregando={isCarregando}>
      <Card titulo="Dados básicos">
        <div className="row">
          <div className="col-lg-4">
            <label>Força:</label>
            <input
              value={getForca()}
              disabled={true}
              className="form-control"/>
          </div>
          <div className="col-lg-4">
            {getUnidade(demanda)}
          </div>
          <div className="col-lg-4">
            <label>Telefone:</label>
            <input
              value={demanda.telefone}
              className="form-control"
              readOnly/>
          </div>
        </div>
        <div className="row mt-2">
          <div className="col-lg-12">
            <label>Objeto:</label>
            <textarea
              value={demanda.objeto}
              rows={10}
              className="form-control"
              readOnly/>
            <span className="small text-danger">Finalidade</span>
          </div>
        </div>
      </Card>

      <Card titulo="Itens">
          <div className="row">
            <div className="col-lg-12">
              <table className="table table-responsive-lg">
              <thead>
              <tr>
                <th style={{"width": "10px"}}>item</th>
                <th>Nome</th>
                <th>Especificação</th>
                <th>Qtd</th>
                <th>Preço unitário</th>
              </tr>
              </thead>

              <tbody>
                {itens.map((v, k) => {
                  return (
                    <tr key={v.id}>
                      <td>{k + 1}</td>
                      <td>{v.item.nome}</td>
                      <td>{v.especificacao}</td>
                      <td>{v.quantidade}</td>
                      <td>
                        <b>{formatarDinheiroItl(v.valorUnitario)}</b>
                        </td>
                    </tr>
                  )
                })}

              </tbody>
            </table>
            </div>
          </div>

          <div className="col-12 pull-right">
            <label className="text-end"> <b>Valor total - {calculaValorTotal()}</b></label>
          </div>

      </Card>

      <Card titulo="Justificativa">
        <div className="row">
          <div className="col-12">
            <textarea
              className="form-control"
              value={demanda.justificativa}
              rows={10}
              readOnly>
            </textarea>
          </div>
        </div>
      </Card>

      <Card titulo="Resultados a serem alcançados">
        <div className="row">
          <div className="col-12">
            <textarea className="form-control"
              value={demanda.resultado}
              rows={10}
              readOnly>
            </textarea>
          </div>
        </div>
      </Card>
      <div className="row">

      </div>
    </PaginaLogada>
  );
}
